// custom start
(function () {
	const FABRIC_SAMPLE_LIMIT = 5
	const FABRIC_SAMPLE_FORM_SELECTOR =
		'product-form.fabric-sample-card__product-form form'
	const FABRIC_SAMPLE_PROPERTY = '_fabric_sample'
	const pendingSampleVariants = new Map()
	let limitCheckQueue = Promise.resolve()

	const getPendingSampleCount = () =>
		Array.from(pendingSampleVariants.values()).reduce(
			(total, quantity) => total + quantity,
			0,
		)

	const reserveSample = (variantId) => {
		pendingSampleVariants.set(
			variantId,
			(pendingSampleVariants.get(variantId) || 0) + 1,
		)
	}

	const releaseSample = (variantId) => {
		const quantity = pendingSampleVariants.get(String(variantId)) || 0
		if (quantity <= 1) {
			pendingSampleVariants.delete(String(variantId))
		} else {
			pendingSampleVariants.set(String(variantId), quantity - 1)
		}
	}

	const countFabricSamples = (cart) => {
		const sampleHandles = new Set(
			Array.from(
				document.querySelectorAll('.fabric-sample-card[data-product-handle]'),
			)
				.map((card) => card.dataset.productHandle)
				.filter(Boolean),
		)

		return (cart.items || []).reduce((total, item) => {
			const properties = item.properties || {}
			const isFabricSample =
				String(properties[FABRIC_SAMPLE_PROPERTY]) === 'true' ||
				sampleHandles.has(item.handle)

			return total + (isFabricSample ? Number(item.quantity) || 0 : 0)
		}, 0)
	}

	const showSampleLimitMessage = () => {
		window.alert(
			'You can add up to 5 free fabric samples per order. Please remove a sample from your cart before adding another.',
		)
	}

	const showSampleCheckError = () => {
		window.alert(
			'We could not check your fabric sample limit. Please try again.',
		)
	}

	const getCart = async () => {
		const response = await fetch(`${routes.cart_url}.js`, {
			headers: { Accept: 'application/json' },
		})
		if (!response.ok) throw new Error('Unable to check the cart')
		return response.json()
	}

	const waitForSampleResult = (variantId) =>
		new Promise((resolve) => {
			let timeoutId
			const finish = () => {
				document.removeEventListener('variant:add', handleResult)
				document.removeEventListener('cart:error', handleResult)
				window.clearTimeout(timeoutId)
				resolve()
			}
			const handleResult = (event) => {
				const resultVariantId =
					event.detail?.variant?.id || event.detail?.productVariantId
				if (String(resultVariantId || '') === variantId) finish()
			}

			document.addEventListener('variant:add', handleResult)
			document.addEventListener('cart:error', handleResult)
			timeoutId = window.setTimeout(finish, 15000)
		})
	const handleFabricSampleSubmit = (event) => {
		const form = event.target.closest(FABRIC_SAMPLE_FORM_SELECTOR)
		if (!form) return

		event.preventDefault()
		event.stopImmediatePropagation()

		const productForm = form.closest('product-form')
		const submitButton = form.querySelector('[type="submit"]')
		const variantInput = form.querySelector('[name="id"]')
		const variantId = String(variantInput?.value || '')
		if (
			!productForm ||
			typeof productForm.onSubmitHandler !== 'function' ||
			!submitButton ||
			!variantId ||
			submitButton.getAttribute('aria-disabled') === 'true'
		) {
			return
		}

		submitButton.disabled = true
		limitCheckQueue = limitCheckQueue
			.then(async () => {
				const cart = await getCart()
				const sampleCount =
					countFabricSamples(cart) + getPendingSampleCount()

				if (sampleCount >= FABRIC_SAMPLE_LIMIT) {
					showSampleLimitMessage()
					return
				}

				reserveSample(variantId)
				submitButton.disabled = false
				const resultPromise = waitForSampleResult(variantId)
				try {
					productForm.onSubmitHandler({ preventDefault() {} })
					await resultPromise
				} finally {
					releaseSample(variantId)
				}
			})
			.catch((error) => {
				console.error('Error checking the fabric sample limit:', error)
				showSampleCheckError()
			})
			.finally(() => {
				if (submitButton.getAttribute('aria-disabled') !== 'true') {
					submitButton.disabled = false
				}
			})
	}

	const releasePendingSample = (event) => {
		const variantId =
			event.detail?.variant?.id || event.detail?.productVariantId
		if (variantId) releaseSample(String(variantId))
	}

	const installFabricSampleLimit = () => {
		if (window.fabricSampleLimitInstalled) return
		window.fabricSampleLimitInstalled = true
		document.addEventListener('submit', handleFabricSampleSubmit, true)
		document.addEventListener('variant:add', releasePendingSample)
		document.addEventListener('cart:error', releasePendingSample)
	}

	installFabricSampleLimit()
	const addSliderClasses = (slider) => {
		const sliderWrapper = slider.querySelector(
			'.fabric-samples-grid-section__wrapper',
		)
		const slides = slider.querySelectorAll('.collection-product-card')

		slider.classList.add('swiper')
		if (sliderWrapper) sliderWrapper.classList.add('swiper-wrapper')

		slides.forEach((slide) => {
			slide.classList.add('swiper-slide')
		})
	}

	const removeSliderClasses = (slider) => {
		const sliderWrapper = slider.querySelector(
			'.fabric-samples-grid-section__wrapper',
		)
		const slides = slider.querySelectorAll('.collection-product-card')

		slider.classList.remove('swiper')
		if (sliderWrapper) sliderWrapper.classList.remove('swiper-wrapper')

		slides.forEach((slide) => {
			slide.removeAttribute('style')
			slide.classList.remove('swiper-slide')
		})
	}

	const initSlider = (section) => {
		const slider = section.querySelector('.swiper--fabric-samples-grid')

		if (slider) {
			addSliderClasses(slider)
			const numberColumns = slider.dataset.columnsMobile || 1

			new Swiper(slider, {
				loop: false,
				speed: 800,
				breakpoints: {
					320: {
						slidesPerView: Number(numberColumns),
						slidesPerGroup: Number(numberColumns),
						spaceBetween: 8,
					},
					750: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 8,
					},
				},
				pagination: {
					el: slider.querySelector('.fabric-samples-grid__pagination'),
					clickable: true,
					type: 'custom',
					renderCustom: function (swiper, current, total) {
						let out = ''
						for (let i = 1; i < total + 1; i++) {
							if (i == current) {
								out = `${out}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`
							} else {
								out = `${out}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`
							}
						}
						return out
					},
				},
			})
		}
	}

	const destroySlider = (section) => {
		const slider = section.querySelector('.swiper--fabric-samples-grid')

		if (slider) {
			removeSliderClasses(slider)
		}
	}

	async function handleResponse(response, section) {
		const responseText = await response.text()
		const html = document.createElement('div')
		html.innerHTML = responseText

		const sourceGrid = html.querySelector('.fabric-samples-grid--search-performed')
		const targetWrapper = section.querySelector(
			'.fabric-samples-grid-section__wrapper',
		)
		if (!sourceGrid || !targetWrapper) {
			section.classList.add('fabric-samples-grid-section--empty')
			return
		}

		targetWrapper.innerHTML = sourceGrid.innerHTML
	}

	const initSliderObserver = (section) => {
		const resizeObserver = new ResizeObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.contentRect.width < 990) {
					initSlider(entry.target)
				} else {
					destroySlider(entry.target)
				}
			})
		})

		resizeObserver.observe(section)
	}

	const initSection = async (section, retryCount = 0) => {
		if (!section || !section.classList.contains('section-fabric-samples-grid')) {
			return
		}

		const box = section.querySelector('.fabric-samples-grid-section')
		if (!box) return

		const isDynamicLoad = box.dataset.isDynamicLoad === 'true'
		const collectionUrl = box.dataset.collectionUrl
		const loadingEl = box.querySelector('.loading-overlay')
		const hasMobileSlider = box.dataset.sliderMobile === 'true'

		if (isDynamicLoad && collectionUrl && collectionUrl !== 'none') {
			box.classList.add('fabric-samples-grid--loading')

			try {
				const response = await fetch(collectionUrl)
				if (response.status === 404 && retryCount === 0) {
					await new Promise((resolve) => setTimeout(resolve, 500))
					return initSection(section, retryCount + 1)
				}
				await handleResponse(response, section)
				if (hasMobileSlider) initSliderObserver(section)
				try {
					if (typeof colorSwatches === 'function') colorSwatches()
				} catch (err) {}
			} catch (error) {
				console.error('Error when fetching products:', error)
				section.classList.add('fabric-samples-grid-section--empty')
			} finally {
				box.classList.remove('fabric-samples-grid--loading')
				if (loadingEl) loadingEl.remove()
			}
		} else {
			box.classList.remove('fabric-samples-grid--loading')
			if (loadingEl) loadingEl.remove()
			if (hasMobileSlider) initSliderObserver(section)
		}
	}

	let activeFabricModal = null
	let activeFabricTrigger = null

	const resetFabricModalTabs = (modal) => {
		modal.querySelectorAll('[data-fabric-detail-tab]').forEach((tab, index) => {
			const isActive = index === 0
			tab.classList.toggle('is-active', isActive)
			tab.setAttribute('aria-selected', String(isActive))
		})
		modal.querySelectorAll('[data-fabric-detail-panel]').forEach((panel, index) => {
			const isActive = index === 0
			panel.classList.toggle('is-active', isActive)
			panel.hidden = !isActive
		})
	}

	const openFabricModal = (trigger) => {
		const card = trigger.closest('.fabric-sample-card')
		const section = trigger.closest('.section-fabric-samples-grid')
		const template = card?.querySelector('.fabric-sample-card__detail-template')
		const modal = section?.querySelector('[data-fabric-detail-modal]')
		const body = modal?.querySelector('[data-fabric-detail-body]')

		if (!template || !modal || !body) return

		if (activeFabricModal && activeFabricModal !== modal) {
			closeFabricModal(activeFabricModal, false)
		}

		body.replaceChildren(template.content.cloneNode(true))
		resetFabricModalTabs(modal)
		modal.classList.add('is-open')
		modal.setAttribute('aria-hidden', 'false')
		document.body.classList.add('fabric-detail-modal-open')
		activeFabricModal = modal
		activeFabricTrigger = trigger
		modal.querySelector('.fabric-detail-modal__dialog')?.focus()
	}

	const closeFabricModal = (modal = activeFabricModal, restoreFocus = true) => {
		if (!modal) return

		modal.classList.remove('is-open')
		modal.setAttribute('aria-hidden', 'true')
		modal.querySelector('[data-fabric-detail-body]')?.replaceChildren()
		document.body.classList.remove('fabric-detail-modal-open')

		if (restoreFocus && activeFabricTrigger) activeFabricTrigger.focus()
		activeFabricModal = null
		activeFabricTrigger = null
	}

	const switchFabricModalTab = (tab) => {
		const modal = tab.closest('[data-fabric-detail-modal]')
		const target = tab.dataset.fabricDetailTab
		if (!modal || !target) return

		modal.querySelectorAll('[data-fabric-detail-tab]').forEach((item) => {
			const isActive = item === tab
			item.classList.toggle('is-active', isActive)
			item.setAttribute('aria-selected', String(isActive))
		})
		modal.querySelectorAll('[data-fabric-detail-panel]').forEach((panel) => {
			const isActive = panel.dataset.fabricDetailPanel === target
			panel.classList.toggle('is-active', isActive)
			panel.hidden = !isActive
		})
	}

	const switchFabricModalImage = (thumbnail) => {
		const product = thumbnail.closest('.fabric-detail-modal__product')
		const image = product?.querySelector('.fabric-detail-modal__image')
		const source = thumbnail.dataset.fabricDetailImage
		if (!image || !source) return

		image.src = source
		image.removeAttribute('srcset')
		product.querySelectorAll('.fabric-detail-modal__thumbnail').forEach((item) => {
			const isActive = item === thumbnail
			item.classList.toggle('is-active', isActive)
			item.setAttribute('aria-pressed', String(isActive))
		})
	}

	const addFabricSampleFromModal = (button) => {
		const modalProduct = button.closest('.fabric-detail-modal__product')
		const handle = modalProduct?.dataset.fabricProductHandle
		const section = button.closest('.section-fabric-samples-grid')
		if (!handle || !section) return

		const card = Array.from(
			section.querySelectorAll('.fabric-sample-card[data-product-handle]'),
		).find((item) => item.dataset.productHandle === handle)
		const form = card?.querySelector('product-form form')

		if (form?.requestSubmit) form.requestSubmit()
	}

	const trapFabricModalFocus = (event) => {
		if (event.key !== 'Tab' || !activeFabricModal) return

		const focusable = Array.from(
			activeFabricModal.querySelectorAll(
				'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])',
			),
		).filter((element) => element.offsetParent !== null)
		if (!focusable.length) return

		const first = focusable[0]
		const last = focusable[focusable.length - 1]
		if (event.shiftKey && document.activeElement === first) {
			event.preventDefault()
			last.focus()
		} else if (!event.shiftKey && document.activeElement === last) {
			event.preventDefault()
			first.focus()
		}
	}

	const installFabricDetailModal = () => {
		if (window.fabricDetailModalInstalled) return
		window.fabricDetailModalInstalled = true

		document.addEventListener('click', (event) => {
			const trigger = event.target.closest('.fabric-sample-card__details-trigger')
			if (trigger) {
				event.preventDefault()
				openFabricModal(trigger)
				return
			}

			const closeButton = event.target.closest('[data-fabric-detail-close]')
			if (closeButton) {
				closeFabricModal(closeButton.closest('[data-fabric-detail-modal]'))
				return
			}

			const tab = event.target.closest('[data-fabric-detail-tab]')
			if (tab) {
				switchFabricModalTab(tab)
				return
			}

			const thumbnail = event.target.closest('[data-fabric-detail-image]')
			if (thumbnail) {
				switchFabricModalImage(thumbnail)
				return
			}

			const sampleButton = event.target.closest('.fabric-detail-modal__sample-button')
			if (sampleButton) addFabricSampleFromModal(sampleButton)
		})

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape' && activeFabricModal) {
				closeFabricModal()
				return
			}
			trapFabricModalFocus(event)
		})
	}

	initSection(document.currentScript.parentElement)
	installFabricDetailModal()

	document.addEventListener('shopify:section:load', function (event) {
		initSection(event.target)
	})
})()
// custom end
